import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugAllopurinol} from "./TextDrugAllopurinol"


export default function Allopurinol() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
    
    <ButtonsText onClick={handleOpen} name='Allopurinol' size='large' color='common.white'   />
    <CustomDialog open={open} onClose={handleClose}

        title="Allopurinol - PGx Recommendation"
        content={ <TextDrugAllopurinol />}

    />

</>
)}